import { render, staticRenderFns } from "./KabYalimo.vue?vue&type=template&id=9a4c714e"
import script from "./KabYalimo.vue?vue&type=script&lang=js"
export * from "./KabYalimo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports